import React, { ReactElement } from 'react';

export const seasonNumberDisplay = { 1: 'ONE', 2: 'TWO', 3: 'THREE' };

export default function SeasonNumber({
  seasonNumber,
}: {
  seasonNumber: number;
}): ReactElement {
  return (
    <a className="no-underline">Season {seasonNumberDisplay[seasonNumber]}</a>
  );
}
